import { providerChoice, paymentTypeStep } from "./elements"

const providers = {
    tinkoff: hidePaymentTypeChoice,
    ukassa: showPaymentTypeChoice
}

providerChoice?.addEventListener("click", onClick);

function onClick(e) {
    const target = e.target.closest('[name="provider"]');

    if (!target) return;

    providers[target.value]()
}

function showPaymentTypeChoice() {
    if (paymentTypeStep) paymentTypeStep.hidden = false
}

function hidePaymentTypeChoice() {
    if (paymentTypeStep) paymentTypeStep.hidden = true
}
